<!-- Version Update Banner -->
@if (showUpdateBanner) {
  <div class="version-update-banner">
    <div class="container-fluid">
      <div class="d-flex align-items-center justify-content-center gap-4">
        <div class="d-flex align-items-center gap-2">
          <i class="ri-information-line fs-20"></i>
          <strong>{{ 'VERSION_UPDATE.TITLE' | translate }}</strong>
        </div>
        <p class="mb-0 banner-message">
          {{ 'VERSION_UPDATE.MESSAGE' | translate }}
        </p>
        <div class="d-flex gap-2 banner-actions">
          <button
            type="button"
            class="btn btn-light btn-sm"
            (click)="dismissUpdateBanner()">
            {{ 'VERSION_UPDATE.DISMISS' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-light btn-sm d-inline-flex align-items-center gap-1 px-3 py-2 refresh-btn"
            (click)="refreshApp()">
            <i class="ri-refresh-line text-primary" style="font-size: 18px; line-height: 1;"></i>
            <span class="text-primary fw-semibold">{{ 'VERSION_UPDATE.REFRESH_NOW' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
}

<ng-progress></ng-progress>
<router-outlet></router-outlet>
<!-- custom container for notifications -->
<div role="status" aria-live="polite" aria-atomic="false" aria-relevant="additions" aria-label="Notifications">
  <notifier-container></notifier-container>
</div>